import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useUser } from "../../user/utils/user";

export default function Footer() {
  const { user } = useUser();
  const [skipValidation, setSkipValidation] = useState(
    localStorage.getItem("skipDistanceValidation") === "true",
  );
  const handleToggleValidation = () => {
    const newValue = !skipValidation;
    localStorage.setItem("skipDistanceValidation", newValue);
    setSkipValidation(newValue);
  };

  return (
    <footer aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl py-4 px-4">
        <div className="mt-12 pt-4">
          <div className="grid grid-cols-3 text-sm text-gray-400">
            <div className="text-left">
              {user?.user?.is_superuser && (
                <button
                  onClick={handleToggleValidation}
                  className="text-gray-300 hover:text-white"
                >
                  {skipValidation
                    ? "Enable distance validation"
                    : "Skip Distance validation"}
                </button>
              )}
            </div>

            <p className="text-center">
              &copy; {new Date().getFullYear()} Ground Truth Analytics LLC
            </p>
            <Link to="/debug">
              <p className="text-right text-gray-300">Advanced</p>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
